<template>
  <div>
    <h1 class="text-pagename">
      Product type {{ store_name != null ? " in " + store_name : null }}
    </h1>
    <v-btn
      absolute
      dark
      fab
      top
      right
      color="primary"
      style="top: 10px"
      @click="toAdd()"
      v-if="sort_data == false"
    >
      <v-icon color="black">add</v-icon>
    </v-btn>

    <storeproductTypeForm
      :dialog="storeProductTypeDialog"
      @setDialog="storeProductTypeDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      :form="form"
      @cancelEdit="cancelEdit()"
    />
    <v-layout row wrap>
      <v-flex xs6 class="text-xs-left">
        <v-toolbar dense flat v-if="sort_data == false">
          <v-btn @click="startSort()" round dark v-if="!isEditProductList"
            >Start sort</v-btn
          >
        </v-toolbar>
      </v-flex>
      <v-flex xs6 v-if="sort_data == false">
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
      <v-flex xs12 v-if="sort_data == true">
        <v-toolbar dense flat>
          <v-btn
            @click="cancelSortData()"
            :loading="cancel_sort"
            :disabled="cancel_sort || sorting_data"
            color="red"
            >Cancel</v-btn
          >
          <label v-if="sort_msg == 3">Can't sort</label>
          <v-btn
            @click="sortData()"
            :loading="sorting_data"
            :disabled="sorting_data || cancel_sort"
            color="green"
            >Apply sort</v-btn
          >
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :loading="fetching_data"
      :search="search"
      :headers="headers"
      :items="product_type_list"
      :hide-actions="hideActionsTable"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="px-1 handle" style="width: 0.1%" v-if="sort_data == true">
          <v-btn style="cursor: move" icon :disabled="sorting_data">
            <v-icon>drag_indicator</v-icon>
          </v-btn>
        </td>
        <td class="text-xs-center" v-else>{{ countIndex(props.item) }}</td>
        <td class="text-xs-center">{{ props.item.product_type_name_th }}</td>
        <td class="text-xs-center">{{ props.item.product_type_name_en }}</td>
        <td class="text-xs-center">{{ props.item.product_type_name_cn }}</td>
        <td class="justify-center layout px-0">
          <v-btn
            icon
            @click="editStoreproductType(props.item, props.index)"
            v-if="sort_data == false"
            :disabled="isEditProductList"
          >
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn
            :disabled="isEditProductList"
            icon
            @click="delType(props.item)"
            v-if="sort_data == false"
          >
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="fetching_data == false">No data available</div>
        <div v-else>Loading ...</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import storeproductTypeForm from "./StoreProductTypeForm.vue";
import { mapGetters, mapState } from "vuex";
export default {
  data: () => ({
    hideActionsTable: false,
    fetching_data: false,
    search: "",
    data_for_sort: {},
    sort_data: false,
    sort_msg: 0,
    cancel_sort: false,
    sorting_data: false,
    original_item: null,
    storeProductTypeDialog: false,
    dialog: false,
    editedIndex: -1,
    form: null,
    pagination: {
      rowsPerPage: 10,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "name",
      },
      {
        text: "Product Type Name TH",
        align: "center",
        value: "product_type_name_th",
        sortable: false,
      },
      {
        text: "Product Type Name EN",
        align: "center",
        value: "product_type_name_en",
        sortable: false,
      },
      {
        text: "Product Type Name CN",
        align: "center",
        value: "product_type_name_cn",
        sortable: false,
      },
      {
        text: "Actions",
        align: "center",
        value: "name",
        sortable: false,
      },
    ],
  }),
  components: {
    storeproductTypeForm,
  },
  destroyed() {
    this.$store.commit("fetchProductTypeBack/resetState");
  },
  computed: {
    ...mapState({
      store_detail_id: (state) => state.storeBack.store_detail_id,
      store_name: (state) => state.storeBack.store_name,
      product_type_list: (state) =>
        state.fetchProductTypeBack.product_type_list,
    }),
    ...mapGetters(["isEditProductList"]),
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.$store.commit("fetchProductTypeBack/getData", []);
    this.initialize();
    this.setFormAdd();
  },
  mounted() {
    let table = document.querySelector(".v-datatable tbody");
    const _self = this;
    Sortable.create(table, {
      handle: ".handle",
      onEnd({ oldIndex, newIndex }) {
        const rowSelected = _self.data_for_sort.splice(oldIndex, 1)[0];
        _self.data_for_sort.splice(newIndex, 0, rowSelected);
      },
    });
  },
  methods: {
    countIndex(item) {
      return this.product_type_list.indexOf(item) + 1;
    },
    startSort() {
      this.hideActionsTable = true;
      this.data_for_sort = JSON.parse(JSON.stringify(this.product_type_list));
      this.sort_data = true;
    },
    async cancelSortData() {
      this.cancel_sort = true;
      await this.getNewData();
      this.cancel_sort = false;
      this.data_for_sort = {};
      this.sort_data = false;
      this.sort_msg = 0;
      this.hideActionsTable = false;
    },
    async sortData() {
      this.sorting_data = true;
      let obj1 = JSON.parse(JSON.stringify(this.data_for_sort));
      for (let key in obj1) {
        delete obj1[key].product_type_count_product;
        delete obj1[key].product_type_name_cn;
        delete obj1[key].product_type_name_th;
        delete obj1[key].product_type_name_en;
        delete obj1[key].product_type_store_id;
        obj1[key].product_type_series = parseFloat(key) + 1;
      }
      this.sort_msg = await this.$store.dispatch(
        "fetchProductTypeBack/SortProductType",
        obj1
      );
      if (this.sort_msg != 3) {
        await this.getNewData();
        this.sort_data = false;
        this.hideActionsTable = false;
      }
      this.sorting_data = false;
    },
    delType(item) {
      confirm("Do you want to delete product type ?") &&
        this.$store.dispatch("fetchProductTypeBack/delType", item);
    },
    toAdd() {
      this.setFormAdd();
      this.storeProductTypeDialog = true;
    },
    setFormAdd() {
      this.form = {
        product_type_name_th: null,
        product_type_name_en: null,
        product_type_name_cn: null,
      };
    },
    cancelEdit() {
      Object.assign(this.form, this.original_item);
      this.setFormAdd();
      this.original_item = null;
    },
    async getNewData() {
      this.fetching_data = true;
      this.$store.commit("fetchProductTypeBack/getData", []);
      await this.$store.dispatch("fetchProductTypeBack/getData");
      this.fetching_data = false;
    },
    async initialize() {
      this.fetching_data = true;
      if (this.store_detail_id == null) {
        let store_detail = await this.$store.dispatch(
          "fetchStoreBack/getStoreDetail",
          this.$route.params.store_id
        );
        this.$store.commit(
          "storeBack/setStoreDetailId",
          store_detail.store.store_id
        );
      }
      await this.$store.dispatch("fetchProductTypeBack/getData");
      this.fetching_data = false;
    },
    setFormEdit(item) {
      this.form = item;
    },
    async editStoreproductType(item, index) {
      await this.setFormEdit(item);
      this.storeProductTypeDialog = true;
      this.editedIndex = index;
      this.original_item = Object.assign({}, item);
    },
  },
};
</script>
<style scoped>
.handle {
  cursor: move !important;
  cursor: -webkit-grabbing !important;
}
</style>

